// src/components/atoms/ThemeToggle/ThemeToggle.tsx

import { useTheme } from '../../../hooks/useTheme'
import styles from './ThemeToggle.module.css'

/*
 * ThemeToggle
 * ──────────────────────────────────────────────
 * Switch pill dark / light.
 * Consomme useTheme() → isDark + toggleTheme.
 * ThemeContext applique la classe "dark" ou "light"
 * sur <html>, ce qui active les variables CSS du thème
 * définies dans index.css.
 */
export function ThemeToggle() {
  const { isDark, toggleTheme } = useTheme()

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={styles.toggle}
      aria-label={isDark ? 'Passer en mode clair' : 'Passer en mode sombre'}
      title={isDark ? 'Mode clair' : 'Mode sombre'}
    >
      <span
        className={`${styles.track} ${isDark ? styles.trackDark : styles.trackLight}`}
      >
        <span className={styles.thumb}>
          {/* Icône Soleil — visible en mode clair */}
          <svg
            className={`${styles.icon} ${styles.sun}`}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="5" />
            <line x1="12" y1="1"     x2="12" y2="3" />
            <line x1="12" y1="21"    x2="12" y2="23" />
            <line x1="4.22" y1="4.22"   x2="5.64" y2="5.64" />
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
            <line x1="1"  y1="12" x2="3"  y2="12" />
            <line x1="21" y1="12" x2="23" y2="12" />
            <line x1="4.22" y1="19.78"  x2="5.64" y2="18.36" />
            <line x1="18.36" y1="5.64"  x2="19.78" y2="4.22" />
          </svg>

          {/* Icône Lune — visible en mode sombre */}
          <svg
            className={`${styles.icon} ${styles.moon}`}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
          </svg>
        </span>
      </span>
    </button>
  )
}